export { default } from './FeatureShowcase.js'
export type { FeatureShowcaseProps, FeatureShowcaseItem } from './types.js'
